import api from '../../services/api';
import {
  GET_TAXES_REQUEST,
  GET_TAXES_SUCCESS,
  GET_TAXES_FAILURE,
  CREATE_TAX_REQUEST,
  CREATE_TAX_SUCCESS,
  CREATE_TAX_FAILURE,
  UPDATE_TAX_REQUEST,
  UPDATE_TAX_SUCCESS,
  UPDATE_TAX_FAILURE,
  DELETE_TAX_REQUEST,
  DELETE_TAX_SUCCESS,
  DELETE_TAX_FAILURE
} from '../types';

// Get all taxes
export const getTaxes = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_TAXES_REQUEST });
    
    const response = await api.get('/taxes', { params });
    
    dispatch({
      type: GET_TAXES_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_TAXES_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch taxes'
    });
    throw error;
  }
};

// Create new tax
export const createTax = (taxData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_TAX_REQUEST });
    
    const response = await api.post('/taxes', taxData);
    
    dispatch({
      type: CREATE_TAX_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: CREATE_TAX_FAILURE,
      payload: error.response?.data?.message || 'Failed to create tax'
    });
    throw error;
  }
};

// Update tax
export const updateTax = (id, taxData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_TAX_REQUEST });
    
    const response = await api.put(`/taxes/${id}`, taxData);
    
    dispatch({
      type: UPDATE_TAX_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: UPDATE_TAX_FAILURE,
      payload: error.response?.data?.message || 'Failed to update tax'
    });
    throw error;
  }
};

// Delete tax
export const deleteTax = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_TAX_REQUEST });
    
    const response = await api.delete(`/taxes/${id}`);
    
    dispatch({
      type: DELETE_TAX_SUCCESS,
      payload: { id, ...response.data }
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: DELETE_TAX_FAILURE,
      payload: error.response?.data?.message || 'Failed to delete tax'
    });
    throw error;
  }
};
